import React, { forwardRef } from 'react';
import { Box, Typography } from '@mui/material';
import { IconName } from '../../constants/icons';
import { GoogleMaterialIcon } from '../ui/GoogleMaterialIcon';
import { tokens, useActiveBranding } from '../../theme/tokens';

interface NavItemProps {
  label: string;
  icon?: IconName;
  isActive?: boolean;
  onClick?: () => void;
}

export const NavItem = forwardRef<HTMLDivElement, NavItemProps>(({ label, icon, isActive, onClick }, ref) => {
  const activeBranding = useActiveBranding();
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;

  return (
    <Box
      ref={ref}
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {icon && (
        <GoogleMaterialIcon
          name={icon}
          size={20}
          color={primaryColor}
          weight={isActive ? 500 : 400}
        />
      )}
      <Typography
        sx={{
          fontSize: '17px',
          fontWeight: isActive ? 700 : 400,
          color: primaryColor,
          transition: 'font-weight 0.3s ease',
          whiteSpace: 'nowrap',
          minWidth: 'max-content',
          '&:hover': {
            fontWeight: 700,
          },
        }}
      >
        {label}
      </Typography>
    </Box>
  );
});